module.exports = __webpack_public_path__ + "img/peiyu.af063ba3.jpg";